import styled from 'styled-components';

export const FormContainer = styled.div`
  padding: 24px 0;

  .ant-input-affix-wrapper {
    margin-bottom: 16px;
  }
`;
